<!-- 批量修改 -->
<template>
  <div>
    <div class="container">
      <div class="e-content">
        <div class="step-wrapper">
          <el-steps :active="activeStep">
            <el-step title="上传文件"></el-step>
            <el-step title="上传中"></el-step>
            <el-step title="上传完成"></el-step>
          </el-steps>
        </div>
      </div>
    </div>
    <div class="container">
      <div class="e-content">
        <div class="upload-content">
          <div class="upload-btn">
            <span>上传文件：</span>
            <el-upload
              ref="upload"
              class="upload-demo"
              :action="upLoadUrl"
              :on-change="handleChange"
              :auto-upload="false"
              :file-list="fileList"
              :headers="headers"
              name="file"
              :on-remove="handleRemove"
              :on-success="handleSuccess"
              :limit="1"
            >
              <el-button size="small" type="primary">点击上传</el-button>
              <div slot="tip" class="el-upload__tip">
                请选择xls或xlsx格式的文件进行上传，若无已导出的模板，请
                <el-button size="small" type="text" @click="downTemplate"
                  >下载模板</el-button
                >
              </div>
            </el-upload>
          </div>
          <div class="upload-btn">
            <el-button v-if="!canUp" type="info" plain disabled>上传</el-button>
            <el-button v-else type="primary" @click="uploadDocument"
              >上传</el-button
            >
            <el-button type="default" @click="goBack">返回</el-button>
          </div>
        </div>
        <div class="tips">
          <p>温馨提示：</p>
          <p>1. excel格式必须是或者xlsx或者xls，属性条数≤200条。</p>
          <p>2. 必填字段不能为空（必填字段名称前面带*），否则将导入失败。</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import axios from 'axios';
import axios from 'more-request/instance';

import { epecToken } from '../../utils/globalData';

export default {
  components: {},
  data() {
    return {
      fileList: [],
      canUp: false,
      upLoadUrl: `${axios.defaults.baseURL}/user-center/member/import`,
      headers: epecToken,
      noUploadFile: [],
      activeStep: 1,
    };
  },

  computed: {},

  created() {},
  methods: {
    handleSuccess(response, file, fileList) {
      console.log(response, file, fileList);
      if (response.code !== '200') {
        this.$message.error(response.message);
      }
    },
    handleChange(file, fileList) {
      if (fileList.length == 1) {
        this.canUp = !this.canUp;
      }
      if (fileList.length > 0) {
        this.fileList = [fileList[fileList.length - 1]]; // 这一步，是 展示最后一次选择的csv文件
        // this.activeStep = 1
      }
    },
    handleRemove(file, fileList) {
      if (fileList.length == 0) {
        this.activeStep = 1;
      }
    },
    downTemplate() {
      axios({
        url: '/user-center/member/excelDown',
        method: 'get',
        responseType: 'blob', // 接收类型设置，否者返回字符型
      }).then((res) => {
        // 定义文件名等相关信息
        const blob = res.data;
        const reader = new FileReader();
        reader.readAsDataURL(blob);
        reader.onload = (e) => {
          const a = document.createElement('a');
          a.download = `批量导入用户模板.xlsx`;
          a.href = e.target.result;
          document.body.appendChild(a);
          a.click();
          document.body.removeChild(a);
        };
      });
    },
    uploadDocument() {
      this.activeStep = 2;
      this.$refs.upload.submit();
      this.activeStep = 3;
    },
    goBack() {
      this.goToUrl();
    },
    goToUrl() {
      this.$store.state.tagsList.map((item, index) => {
        if (item.fullPath == this.$route.path) {
          this.$store.state.tagsList.splice(index, 1);
        }
      });
      this.$router.go(-1);
    },
  },
};
</script>
<style lang="scss" scoped>
.e-content {
  width: 80%;
  margin: 0 auto;
  .tips {
    margin-top: 20px;
    margin-left: 32%;
    p {
      font-size: 12px;
      color: #606266;
    }
  }
}
.upload-content {
  margin-top: 50px;
  .upload-btn {
    margin-top: 20px;
    display: flex;
    justify-content: center;
  }
}
</style>
